import script from "./CommonUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonUpload.vue?vue&type=script&setup=true&lang=js"

import "./CommonUpload.vue?vue&type=style&index=0&id=62c57248&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c57248"]])

export default __exports__